
import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { debounce } from '@/assets/script/utils/index.js'

gsap.registerPlugin(ScrollTrigger)

export default {
  anme: 'View',
  props: {
    page: {
      type: Object,
      required: true,
    },
    socialData: {
      type: Object,
      required: true,
    },
    relatedPosts: {
      type: Object,
      default: () => ({}),
    },
  },
  data: () => ({
    progress: undefined,
    tl: undefined,
  }),
  computed: {
    categories() {
      const filtered = this.page.postBy.categories.nodes.filter(
        (category) =>
          // Rimuovo le categorie che non hanno pagine dedicate e nella configurazione sono segnalate in navigation/exclude
          !this.$configuration.navigation.exclude.includes(
            this.$getCategoryRoute(category.slug, 'wpSlug').key
          )
      )
      return filtered
    },
  },
  beforeDestroy() {
    if (ScrollTrigger.getById('hideShowItems'))
      ScrollTrigger.getById('hideShowItems').kill()
    if (this.tl) {
      this.tl.kill()
      this.tl = undefined
    }
    gsap.set('.layout__header', { clearProps: 'all' })
  },
  mounted() {
    this.switchTween()

    // Assegno la larghezza dello screen al load e controllo se varia nel resize per chiamare le funzioni perché los croll del mobile triggera il resize e quindic rea prolbemi con le animazioni.
    let oldInnerWidth = window.innerWidth
    // Reinizializzo lo scroll progress al resize così si resetta le misure
    window.addEventListener(
      'resize',
      debounce((val) => {
        if (window.innerWidth !== oldInnerWidth) {
          this.switchTween()
          if (this.$refs.scrollProgress) {
            this.$refs.scrollProgress.killAnimations()
            this.$refs.scrollProgress.setup()
          }
          oldInnerWidth = window.innerWidth
        }
      }, 150),
      { passive: true }
    )
    // Ricalcolo le misure dato che carico i componenti in lazy. Migliorabile
    setTimeout(() => {
      window.dispatchEvent(new Event('resize'))
    }, 250)
  },
  methods: {
    async switchTween() {
      if (this.tl) {
        this.tl.kill()
        this.tl = undefined
      }
      await gsap.set(
        '.layout__header, .layout__search, .scroll-top, .scroll-progress__rail, .article-sub-header',
        {
          clearProps: 'all',
        }
      )
      if (window.matchMedia('(min-width: 1100px)').matches) {
        this.tl = await gsap
          .timeline({
            scrollTrigger: {
              id: 'hideShowItems',
              scroller: document.body,
              trigger: document.querySelector('.layout__main__progress'),
              start: 'top top',
              end: 'bottom center',
              toggleActions: 'play reverse play reverse',
            },
          })
          /* .to(document.querySelectorAll('.layout__header, .layout__search'), {
            duration: 0.4,
            autoAlpha: 0,
          }) */
          .from(
            document.querySelectorAll(
              '.scroll-top, .scroll-progress__rail, .article-sub-header, .layout__main__adv'
            ),
            {
              duration: 0.4,
              autoAlpha: 0,
            }
          )
      } else {
        this.tl = await gsap
          .timeline({
            scrollTrigger: {
              id: 'hideShowItems',
              scroller: document.body,
              trigger: document.querySelector('.layout__main__progress'),
              start: 'top top',
              end: 'bottom center',
              toggleActions: 'play reverse play reverse',
            },
          })
          .from(document.querySelector('.scroll-progress__rail'), {
            duration: 0.4,
            autoAlpha: 0,
          })
      }
    },
  },
}
